/* eslint-disable @typescript-eslint/no-explicit-any */
import type { DataTableProps } from "@/types/DataTableTypes";
import { StickyTable } from "./components/StickyTable";
import { DynamicTable } from "./components/DynamicTable";

/**
 * SntDataTable - Main data table component
 *
 * @param props - DataTableProps with the following options:
 *  - dataFilter: Data filter configuration
 *  - data: Table data
 *  - onConfigColumn: Callback when column config is clicked
 *  - loading: Loading state
 *  - noDataText: Text to show when no data
 *  - isShowSelectPageSize: Show page size selector (default: true)
 *  - isFloatingFooter: Enable floating footer (default: true)
 *  - isShowPaging: Show pagination (default: true)
 *  - isShowDecoratorColor: Show row decorator color (default: false)
 *  - isDisabbledGroup: Disable grouping (default: true)
 *  - onRenderConfig: Custom config renderer
 *  - isDynamicDashBoard: Use DynamicTable for dashboard widgets
 *  - height: Height for DynamicTable
 *
 * @returns StickyTable or DynamicTable based on isDynamicDashBoard prop
 */
export const SntDataTable = (props: DataTableProps) => {
  const { isDynamicDashBoard } = props;

  if (isDynamicDashBoard) {
    return <DynamicTable {...(props as any)} />;
  }

  return <StickyTable {...props} />;
};
